

module.exports = {
    path: '/**',
    component: require('./NotFound')
};



// WEBPACK FOOTER //
// ./src/app/components/not-found/route.NotFound.js